<script lang="ts">
import FicheProfil from '@/generated/fiches/FicheProfil.vue';
import { Extended } from '@/framework/base/classes/Schema';
import Adresse from '@/extend/classes/Adresse';
import { storeAdresse } from '@/generated/stores';
import { ObjTypes } from '@/generated/classes/ObjTypes';
import Owner from '@/generated/classes/Owner';
import { defineComponent } from "vue";

export default defineComponent({
  components: {},
  extends: FicheProfil,
  data() {
    return {
      adresseId: 0
    };
  },
  computed: {
    selectedAdresse(): Adresse {
      if (this.adresse.id < 0) {
        storeAdresse.mAdresseDeleted(this.adresse.id);
      }
      this.updateAdresseOwner();
      return this.adresse;
    }
  },
  methods: {
    updateAdresseOwner() {
      if (this.contact.adresseId == 0) {
        this.adresse = storeAdresse.createNewAdresse();
      } else {
        this.adresse = storeAdresse.getAdresse(this.contact.adresseId);
      }
      this.adresse.owner = new Owner()
      this.adresse.owner.objType = ObjTypes.CONTACT;
      this.adresse.owner.objId = this.contact.id;
    },
    isDisplayed(value: string): boolean {
      if (this.contact.id < 0 && value == 'CONTACT') {
        this.setExtended(new Extended('CONTACT', this.fiche, true));
      }
      return true;
    }
  }
})

</script>
